import * as React from 'react';
import styled from 'styled-components';
import { ButtonWithClickAnalytic, ButtonWithAnalyticProps } from './ButtonWithClickAnalytic';

const Button = styled.button`
  background-color: ${(props) => props.theme.colors.primary};
  height: 55px;
  width: 310px;
  border-radius: 28px;
  font-size: 18px;
  color: ${(props) => props.theme.colors.foreground};
  font-family: Roboto, Arial, Helvetica, sans-serif;
  border: none;
  cursor: pointer;
  &:focus {
    outline: none;
  }
  &:disabled {
    pointer-events: none;
    opacity: 0.2;
  }
`;

export const PartnerButton: React.FunctionComponent<ButtonWithAnalyticProps> = ButtonWithClickAnalytic(Button);



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/buttons/PartnerButton.tsx